import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminOrders from "@/pages/AdminOrders";
import Info from "@/pages/Info";
import Track from "@/pages/Track";
import AccountLogin from "@/pages/account/Login";
import AccountSignup from "@/pages/account/Signup";
import AccountDashboard from "@/pages/account/Dashboard";
import CustomerProtectedRoute from "@/components/CustomerProtectedRoute";
import Loader from "@/components/Loader";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CustomerAuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Loader />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<Success />} />
                <Route path="/cancel" element={<Cancel />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/track" element={<Track />} />
                <Route path="/faq" element={<Info slug="faq" />} />
                <Route path="/shipping" element={<Info slug="shipping" />} />
                <Route path="/returns" element={<Info slug="returns" />} />
                <Route path="/account/login" element={<AccountLogin />} />
                <Route path="/account/signup" element={<AccountSignup />} />
                <Route
                  path="/account"
                  element={
                    <CustomerProtectedRoute>
                      <AccountDashboard />
                    </CustomerProtectedRoute>
                  }
                />
                <Route
                  path="/admin/orders"
                  element={
                    <ProtectedRoute>
                      <AdminOrders />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              <Toaster position="bottom-right" theme="light" />
            </BrowserRouter>
          </CartProvider>
        </CustomerAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
